import React from "react";
//#region types
import { ReportListItemProps } from "models/propTypes/reportsPropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { RoundedIcon } from "components/common";
import { useNavigate, useLocation } from "react-router-dom";
//#endregion
import { UrlHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const ReportListItem: React.FC<ReportListItemProps> = (props) => {
  const {
    reportKey,
    icon = IconDefinitionConstants.WReports,
    title,
    description,
    tags,
    reportUrl,
    displayType,
  } = props;
  const location = useLocation();
  const navigate = useNavigate();

  const onItemClick = () => {
    if (reportUrl) {
      navigate(UrlHelper.formatPath(reportUrl), {
        state: { background: location },
      });
    }
  };

  return (
    <Grid id={`report-${reportKey}`} container className={cssExports.reportNavListItem} onClick={onItemClick}>
      <Grid container direction="row" columnGap={3}>
        <Grid item>
          <RoundedIcon icon={icon} displayType={displayType} />
        </Grid>
        <Grid container item xs>
          <Grid container className={cssExports.title}>
            {title}
          </Grid>
          <Grid container className={cssExports.description}>
            {description}
          </Grid>
          {tags && tags.length > 0 ? (
            <Grid container className={cssExports.tags}>{`# ${tags.join(", ")}`}</Grid>
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ReportListItem;
